import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import axiosInstance from "../../interceptor/axiosInstance";
import { Branch, Branches } from "../../models/InstituteModel/branches.model";
import { deserialize, serialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { generatePath } from "react-router-dom";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";

export default class BranchService {
  static fetchBranches(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.BRANCHES_LIST, { params })
      .then((response) => {
        const branches = deserialize(Branches, response.data["branches"]);
        const meta = deserialize(PaginationModel, response?.data["meta"]);
        onSuccess(branches, meta);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching branches",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static showBranch(
    branchId: string,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.SINGLE_BRANCH, { branchId });
    axiosInstance
      .get(API_URL)
      .then((response) => {
        const branch = deserialize(Branches, response.data["branch"]);
        onSuccess(branch);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching branch",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static createBranch(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .post(ApiRoutes.BRANCHES_LIST, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const branch = deserialize(Branches, response.data["branch"]);
        onSuccess(branch);
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating branch",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static updateBranch(
    branchId: any,
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.SINGLE_BRANCH, { branchId });
    axiosInstance
      .put(API_URL, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const branch = deserialize(Branches, response.data["branch"]);
        onSuccess(branch);
      })
      .catch((error) => {
        Notification({
          message: "Problem in updating branch",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static deleteBranch(
    branchId: string,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.SINGLE_BRANCH, { branchId });
    axiosInstance
      .delete(API_URL)
      .then((response) => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in deleting branch",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
}
